import React, { useEffect, useState } from "react";
import { Card, Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { sendInvitePeople } from "../../redux/actions/authAction";
import { ToastContainer } from "react-toastify";
import { toastify } from "../../components/Toast";

const InviteUser = () => {
  const dispatch = useDispatch();
  const { allOrganizations } = useSelector(
    (state) => state.getOrganizationData
  );
  const [email, setEmail] = useState("");
  const [results, setResults] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedOrganizationState, setSelectedOrganizationState] =
    useState("");

const onSendInviteHandler = async () => {
  setLoader(true);
  if (!selectedOrganizationState) {
    toastify("error", "Please select an organization.");
    setLoader(false);
    return;
  }

  const emailList = email.split(/[\n,]+/).map(e => e.trim()).filter(e => e);

  if (!emailList || emailList.length === 0) {
    toastify("error", "Please enter at least one valid email");
    setLoader(false);
    return;
  }

  const payload = {
    emails: emailList,
    organizationId: selectedOrganizationState,
  };

  dispatch(sendInvitePeople(payload, handleInviteResponse, setLoader));
};

const handleInviteResponse = (response) => {
  console.log("RESPONSE: ", response)
  if (response && response?.data?.results) {
    setResults(response?.data?.results);
  }
  setLoader(false);
};
  return (
    <>
      <>
        <ToastContainer />
      </>
      <div className="invite-user">
        <div className="row mb-3 pt-5 pl-5">
          <div className="col-md-6">
            <h1 className="healthKitUpdateHeaderFont d-flex">Invite Users</h1>
          </div>
          <div className="col-md-6 d-flex justify-content-end"></div>
        </div>
        <div className="invite-user-container">
          <Card className="pt-4 pr-4 pl-4 pb-2 m-5">
            <>
              <Form>
                <Form.Group
                  className="mb-3 organization-container-with-email"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>
                    <h4 className="d-flex font-weight-bold">
                      Select organization
                    </h4>
                  </Form.Label>

                  <>
                    <form className="goalSelectorFieldForm">
                      <select
                        className="goalSelectorField"
                        onChange={(event) =>
                          setSelectedOrganizationState(event.target.value)
                        }
                        value={selectedOrganizationState}
                      >
                        <option
                          value=""
                          disabled
                          selected
                          className="first-options"
                        >
                          Select your organization
                        </option>
                        {allOrganizations?.data?.map((organization, index) => {
                          return (
                            <>
                              <option value={organization?._id}>
                                {organization?.organizationName}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </form>
                  </>
                </Form.Group>
              </Form>
            </>
            <Form.Group className="mb-3">
              <Form.Label className="w-100 text-start">
                <h4 className="font-weight-bold">Add emails</h4>
                <small className="text-muted d-block">
                  Separate each email with a comma
                </small>
              </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="eqwell@example.com, eqwell@bar.com, eqwell@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

            <div className="send-invite-btn mt-3 mb-2">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={onSendInviteHandler}
                disabled={loader}
              >
                {loader ? (
                  <Spinner
                    className=""
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "  Send"
                )}
              </button>
            </div>
            {results.length > 0 && (
            <div className="mt-4">
              <h5 className="font-weight-bold mb-3">Invite Summary</h5>
              <ul
                className="list-group"
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  paddingRight: "8px",
                  marginBottom: "1.5rem",
                }}
              >
                {results.map((r, i) => (
                  <li
                    key={i}
                    className={`list-group-item d-flex justify-content-between align-items-center ${
                      r.status === "success"
                        ? "list-group-item-success"
                        : "list-group-item-danger"
                    }`}
                  >
                    <span>
                      <strong>{r.email}</strong>
                    </span>
                    <span>
                      {r.status}:{" "}
                      {r.message.startsWith("E11000 duplicate key error collection")
                        ? "User already invited"
                        : r.message}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          </Card>
        </div>
      </div>
    </>
  );
};

export default InviteUser;
